import {
    FormControl,
    IconButton,
    makeStyles,
    MenuItem,
    OutlinedInput,
    Select,
    TextField
} from '@material-ui/core'
import Clear from '@material-ui/icons/Clear'
import { Autocomplete } from '@material-ui/lab'
import React, { useEffect, useState } from 'react'
import { Checkbox } from '..'
import { DEVICE_TYPE, REPRESENTATION } from '../../../constants'
import { REPORT_SEVERITY } from '../../../hooks/useReportTypes'
import Input from '../input'
import { OptionSwitcher } from '../option-switcher/option-switcher'
import { useSelector } from 'react-redux'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import classnames from 'classnames'
import { UserPermissions } from '../../../../../services/permissions'
const checkboxIcon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedCheckboxIcon = <CheckBoxIcon fontSize="small" />

export const DISPLAY_PICKER_REPORT_TYPES = [
    1, // Online, must add on request 0, 3, 11
    2,
    4,
    5,
    6,
    12,
    13,
    15,
    16,
    17,
    18,
    19,
    20,
    // 21, can not be set as last_report_type
    22,
    23,
    24
    // 25, can not be set as last_report_type
]

export const DeviceFilters = ({
    filters,
    locale,
    onChange,
    className,
    location
}) => {
    const classes = useStyles()
    const { theme } = useSelector(state => state.main)

    const [operationMode, setOperationMode] = useState(
        getSelectedOperationModes(filters)
    )
    const [reportTypes, setReportTypes] = useState(
        filters.report_types.map(reportType => {
            const name =
                Number(reportType) === 3 || Number(reportType) === 1
                    ? `${locale.devices.deviceLastReportTypeShortDescription[reportType]}, ${locale.devices.deviceLastReportTypeShortDescription['3-bait']}`
                    : locale.devices.deviceLastReportTypeShortDescription[
                          reportType
                      ]
            return {
                reportType,
                name
            }
        })
    )

    const statusPickerOptions = DISPLAY_PICKER_REPORT_TYPES.map(reportType => ({
        reportType,
        // the Online report types are grouped in prepareFilters function
        // 3 is being added to the report types array if 1 is present
        name:
            Number(reportType) === 3 || Number(reportType) === 1
                ? `${locale.devices.deviceLastReportTypeShortDescription[reportType]}, ${locale.devices.deviceLastReportTypeShortDescription['3-bait']}`
                : locale.devices.deviceLastReportTypeShortDescription[
                      reportType
                  ]
    }))

    const filterCheckboxes = [
        {
            label: locale.devices.online,
            key: REPORT_SEVERITY.info
        },
        {
            label: locale.devices.stock,
            key: REPORT_SEVERITY.inactive
        },
        {
            label: locale.devices.warning,
            key: REPORT_SEVERITY.warning
        },
        {
            label: locale.devices.error,
            key: REPORT_SEVERITY.critical
        }
    ]

    const handleChangeOperationMode = event => {
        const {
            target: { value }
        } = event

        const mappedValue = value
            .map(i => {
                const [device_type, operation_mode] = i.split(':')
                return {
                    device_type,
                    operation_mode
                }
            })
            .reduce(
                (acc, { device_type, operation_mode }) => {
                    if (!acc.operation_modes.includes(operation_mode)) {
                        acc.operation_modes.push(operation_mode)
                    }
                    if (!acc.device_types.includes(device_type)) {
                        acc.device_types.push(device_type)
                        if (device_type === DEVICE_TYPE.jerry) {
                            acc.device_types.push(DEVICE_TYPE['jerry-lora'])
                            acc.device_types.push(DEVICE_TYPE['jerry-bait-rat'])
                        }
                    }

                    return acc
                },
                {
                    operation_modes: [],
                    device_types: []
                }
            )

        onChange({ type: 'operationMode', value: mappedValue })

        setOperationMode(
            // On autofill we get a the stringified value.
            typeof value === 'string' ? value.split(',') : value
        )
    }

    const handleChangeStatus = event => {
        const {
            target: { value }
        } = event

        onChange({ type: 'status', value })
    }

    const onSearch = value => {
        onChange({ type: 'search', value: value.trim() })
    }

    let isAssignedSwitcherVisible = false
    if (location) {
        isAssignedSwitcherVisible =
            (UserPermissions.isAllOriginalGranted() &&
                UserPermissions.isOriginalEntity(location?.customer_id)) ||
            UserPermissions.isTraplinkedAdmin()
    } else {
        isAssignedSwitcherVisible = UserPermissions.isAllOriginalGranted()
    }

    useEffect(() => {
        onChange({
            type: 'status',
            value: reportTypes.map(item => item.reportType)
        })
    }, [reportTypes])

    return (
        <div className={classnames([classes.filtersWrapper, className])}>
            {isAssignedSwitcherVisible && (
                <OptionSwitcher
                    large
                    className={classes.switcher}
                    options={{
                        [REPRESENTATION.all]: locale.devices.allDevices,
                        [REPRESENTATION.assigned]: locale.devices.assigned
                    }}
                    selected={
                        filters.is_assigned
                            ? REPRESENTATION.assigned
                            : REPRESENTATION.all
                    }
                    onChange={value =>
                        onChange({
                            type: 'is_assigned',
                            value: value === REPRESENTATION.assigned
                        })
                    }
                />
            )}
            <FormControl className={classes.filterSelectOperationMode}>
                <Select
                    variant="outlined"
                    multiple
                    displayEmpty
                    placeholder="deviceType"
                    value={operationMode}
                    onChange={handleChangeOperationMode}
                    MenuProps={{
                        variant: 'menu'
                    }}
                    input={
                        <OutlinedInput
                            placeholder="deviceType"
                            classes={{ root: classes.input }}
                        />
                    }
                    renderValue={selected => {
                        if (selected.length === 0) {
                            return (
                                <span className={classes.placeholderFilter}>
                                    {locale.devices.deviceOperationMode}
                                </span>
                            )
                        }

                        const selectedToShow =
                            selected.length > 3
                                ? selected.slice(0, 2)
                                : selected

                        return selectedToShow
                            .map(
                                i =>
                                    locale.devices.operationMode[
                                        i.split(':')[1]
                                    ]
                            )
                            .join(', ')
                    }}
                >
                    <MenuItem disabled value="">
                        <span>{locale.devices.deviceTypes.jerry}</span>
                    </MenuItem>
                    <MenuItem value="jerry:snaptrap">
                        <Checkbox
                            checked={
                                operationMode.indexOf('jerry:snaptrap') > -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.snaptrap}
                        </span>
                    </MenuItem>
                    <MenuItem value="jerry:bait">
                        <Checkbox
                            checked={operationMode.indexOf('jerry:bait') > -1}
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.bait}
                        </span>
                    </MenuItem>
                    <MenuItem disabled value="">
                        <span>{locale.devices.deviceTypes.tom}</span>
                    </MenuItem>
                    <MenuItem value="tom:insect">
                        <Checkbox
                            checked={operationMode.indexOf('tom:insect') > -1}
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.insect}
                        </span>
                    </MenuItem>
                    <MenuItem value="tom:movement">
                        <Checkbox
                            checked={operationMode.indexOf('tom:movement') > -1}
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.movement}
                        </span>
                    </MenuItem>
                    <MenuItem value="tom:snaptrap">
                        <Checkbox
                            checked={operationMode.indexOf('tom:snaptrap') > -1}
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.snaptrap}
                        </span>
                    </MenuItem>
                    {/* {filterCheckboxes.map(({ label, key }) => (
                <MenuItem
                    key={key}
                    value={key}
                >
                    <Checkbox checked={filterStatus.indexOf(key) > -1} />
                    <span className={classes.statusFilterItem}>{label}</span>
                </MenuItem>
            ))} */}
                    <MenuItem disabled value="">
                        <span>{locale.devices.deviceTypes['trapsensor']}</span>
                    </MenuItem>
                    <MenuItem value="trapsensor:snaptrap">
                        <Checkbox
                            checked={
                                operationMode.indexOf('trapsensor:snaptrap') >
                                -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.snaptrap}
                        </span>
                    </MenuItem>
                    <MenuItem disabled value="">
                        <span>{locale.devices.deviceTypes['tm01-1']}</span>
                    </MenuItem>
                    <MenuItem value="tm01-1:snaptrap">
                        <Checkbox
                            checked={
                                operationMode.indexOf('tm01-1:snaptrap') > -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.snaptrap}
                        </span>
                    </MenuItem>
                </Select>
            </FormControl>

            <Autocomplete
                className={classes.filterSelect}
                multiple
                options={statusPickerOptions}
                style={{ width: 400 }}
                limitTags={1}
                getOptionLabel={option => option.name}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={locale.devices.status}
                        variant="outlined"
                        InputProps={{
                            ...{
                                style: { borderRadius: theme.borderRadius }
                            },
                            ...params.InputProps
                        }}
                    />
                )}
                getOptionSelected={(option, value) => {
                    return option.reportType === value.reportType
                }}
                renderOption={(option, { selected }) => {
                    return (
                        <React.Fragment>
                            <Checkbox
                                icon={checkboxIcon}
                                checkedIcon={checkedCheckboxIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option.name}
                        </React.Fragment>
                    )
                }}
                value={reportTypes}
                onChange={(event, newValue) => {
                    setReportTypes(newValue)
                }}
                noOptionsText={locale.common.nothingWasFound}
            />
            {/* 
            <FormControl className={classes.filterSelect}>
                <Select
                    multiple
                    displayEmpty
                    placeholder={locale.devices.status}
                    value={filters.report_types}
                    onChange={handleChangeStatus}
                    MenuProps={{
                        variant: 'menu'
                    }}
                    input={
                        <OutlinedInput
                            placeholder={locale.devices.status}
                            classes={{ root: classes.input }}
                        />
                    }
                    renderValue={selected => {
                        if (selected.length === 0) {
                            return (
                                <span className={classes.placeholderFilter}>
                                    {locale.devices.status}
                                </span>
                            )
                        }

                        const selectedToShow =
                            selected.length > 3
                                ? selected.slice(0, 2)
                                : selected

                        return selectedToShow
                            .map(i => locale.devices.filters?.[i])
                            .join(', ')
                    }}>
                    <MenuItem disabled value="">
                        <span>{locale.devices.status}</span>
                    </MenuItem>
                    {filterCheckboxes.map(({ label, key }) => (
                        <MenuItem key={key} value={key}>
                            <Checkbox
                                checked={filters.report_types.indexOf(key) > -1}
                            />
                            <span className={classes.statusFilterItem}>
                                {label}
                            </span>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl> */}
            <Input
                value={filters.search}
                className={classes.searchInput}
                label={locale.common.search}
                type="text"
                setValue={onSearch}
                debounce={600}
                endIcon={() =>
                    filters.search ? (
                        <IconButton
                            size="small"
                            onClick={() => onSearch('')}
                            classes={{ root: classes.saerchClearIcon }}
                        >
                            <Clear />
                        </IconButton>
                    ) : null
                }
            />
        </div>
    )
}

const getSelectedOperationModes = ({ operation_modes, device_types }) => {
    // TODO use constants for device types
    let res = []
    if (device_types.includes('jerry')) {
        operation_modes.forEach(el => {
            res.push(`jerry:${el}`)
        })
    }
    if (device_types.includes('tom')) {
        operation_modes.forEach(el => {
            res.push(`tom:${el}`)
        })
    }
    if (device_types.includes('tm01-1')) {
        res.push('tm01-1:snaptrap')
    }
    if (device_types.includes('trapsensor')) {
        res.push('trapsensor:snaptrap')
    }
    return res
}

const useStyles = makeStyles(theme => ({
    switcher: {
        marginRight: 12,
        marginBottom: 16
    },
    input: {
        fontSize: 14,
        // height: '32px',
        // width: 150,
        borderRadius: theme.borderRadius
        // marginRight: 32
    },
    filtersWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap'
    },
    filterSelectOperationMode: {
        width: 150,
        marginRight: 12,
        marginBottom: 16
    },
    filterSelect: {
        marginRight: 13,
        marginBottom: 16
    },
    statusFilterItem: {
        fontSize: 14
    },
    placeholderFilter: {
        color: theme.palette.text.secondary
    },
    searchInput: {
        width: 170,
        marginBottom: 16
    },
    saerchClearIcon: {
        padding: 0,
        position: 'absolute',
        right: 14
    }
}))
